import React, { useState } from "react";
import img01 from "./../../../assets/images/GBVimg.jpg";// Adjust the path as necessary

function AboutGBV() {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [currentSection, setCurrentSection] = useState("section1");

  const sectionData = {
    section1: {
      title: "Participating in the development and implementation of national",
      description:
        "Participating in the development and implementation of national and international maritime safety and marine environment protection standards.",
    },
    section2: {
      title: "Enforcing technical and operational standards for all shipping",
      description:
        "Enforcing technical and operational standards for all shipping operations in South African waters and for South African ships anywhere, to promote responsible operations in terms of seaworthiness, safety and pollution prevention.",
    },
    section3: {
      title: "Enforcing training standards and competency of Seafarers",
      description: "Enforcing training standards and competency of Seafarers.",
    },
    section4: {
      title: "Managing the national capability to respond to marine pollution",
      description:
        "Managing the national capability to respond to marine pollution incidents and other maritime emergencies.",
    },
    section5: {
      title: "Operating the Maritime Rescue Co-ordination Centre",
      description:
        "Operating the Maritime Rescue Co-ordination Centre to coordinate maritime assistance services and to detect, and co-ordinate the location and rescue of people in maritime distress situations throughout the internationally agreed South African Search and Rescue Region.",
    },
    section6: {
      title: "Overseeing the provision of maritime distress and safety",
      description:
        "Overseeing the provision of maritime distress and safety communications services to discharge South Africa's responsibilities under the Global Maritime Distress and Safety System.",
    },
    section7: {
      title: "Administering South Africa's voluntary ship reporting system",
      description:
        "Administering South Africa's voluntary ship reporting system (SAFREP) for identifying and tracking ships at sea for safety purposes and to provide a ships' database for responding to marine emergencies.",
    },
    section8: {
      title: "Investigating maritime casualties",
      description: "Investigating maritime casualties.",
    },
    section9: {
      title: "Delivering related services including",
      description: "Delivering related services including.",
    },
    section10: {
      title: "Public awareness and education in marine safety and pollution",
      description:
        "Public awareness and education in marine safety and pollution prevention.",
    },
    section11: {
      title: "Administration of South Africa's ship registration system",
      description: "Administration of South Africa's ship registration system.",
    },
    section12: {
      title:
        "Publication of, and access to, ship safety and environmental standards",
      description:
        "Publication of, and access to, ship safety and environmental standards.",
    },
  };

  const sections = Object.entries(sectionData);

  const handleToggle = (index, key) => {
    setExpandedIndex(expandedIndex === index ? null : index);
    setCurrentSection(key);
  };


  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        What do we know
        <span className="text-orange-ef3e33 font-400"> about GBV at sea?
        </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <div className="service-title font-700 mb-3 text-uppercase">
          </div>

          <p className="text-primary-color mb-3">Working on board vessels is regarded as one of the most challenging jobs in the world, as seafarers find themselves away from families for extended periods of time whilst sailing in often treacherous conditions. This makes working at sea not just a dangerous job but also a mentally stressful environment. Seafarers are also often unable to communicate with families and friends for extended periods until they are in a port. The nature of the job isolates the individuals from their social and security net. This then make those working on board vessels vulnerable or compromised when it comes to safety, security and working conditions. </p>

          {/* <ul class="green-star-ul">
             <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
               
           </ul>   */}



        </div>
        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
            {/* <div className="col-lg-12 col-md-6 col-sm-6">
               <img src={img01} className="img-fluid rounded-1" alt="" />
             </div> */}
          </div>
        </div>
        <div className="accordion blackTab" id="blackTab">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabOne"
                aria-expanded="false"
                aria-controls="blackTabOne">
                There have always been murmurings about GBV at sea with the maritime fraternity
              </button>
            </h2>
            <div id="blackTabOne"
              className="accordion-collapse collapse"
              data-bs-parent="#blackTab">
              <div className="accordion-body">
                <p className="mb-3">
                  There have always been murmurings about GBV at sea with the maritime fraternity seemingly in denial or not aggressively tackling the issue. Studies from 2014 revealed that 17% of women seafarers reported sexual harassment. The reports further indicated that women with less power in the workplace were more vulnerable to sexual harassment. This basically means young people, cadets and junior officers are more vulnerable.
                </p>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button "
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabTwo"
                aria-expanded="true"
                aria-controls="blackTabTwo">Recent studies and surveys are putting the figure of female seafarers reporting
              </button>
            </h2>
            <div id="blackTabTwo"
              className="accordion-collapse collapse show"
              data-bs-parent="#blackTab">
              <div className="accordion-body">
                <p className="mb-3">Recent studies and surveys are putting the figure of female seafarers reporting sexual harassment at 25% and those who have experienced or noticed sexual harassment at over 55%. At least 8% of women are reported to have suffered sexual assault. The numbers could be higher as female seafarers seem to shy away from reporting as they fear retribution, stigmatization and backlisting.

                </p>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabThree"
                aria-expanded="false"
                aria-controls="blackTabThree">
                South Africa had its fair share of sexual harassment and assault cases leaving the victims
              </button>
            </h2>
            <div id="blackTabThree"
              className="accordion-collapse collapse"
              data-bs-parent="#blackTab">
              <div className="accordion-body">
                <p className="mb-3">South Africa had its fair share of sexual harassment and assault cases leaving the victims with lifelong scars and even fatal consequences. There has also been an increase in reported cases of bullying including beatings reported in South African ports. There is clear evidence that seafarers are not immune to GBV.  However, current international regulations do not seem to offer adequate protection against GBV. There are positive developments at international level after the IMO took note of recent spikes in incidents of GBV at Sea. In 2022, the IMO and ILO came together and formed Joint ILO/IMO Tripartite
                  Working Group (JTWG) to identify and address seafarers' issues and the human element with one group focusing on identifying gaps in current regulations and recommending future action to address bullying and harassment, including sexual assault and sexual harassment, in the maritime sector.
                </p>
              </div>
            </div>

          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabFour"
                aria-expanded="false"
                aria-controls="blackTabFour">
                South Africa was nominated as one of the 8 (eight) IMO Member States to be part of the JTWG.
              </button>
            </h2>
            <div id="blackTabFour"
              className="accordion-collapse collapse"
              data-bs-parent="#blackTab">
              <div className="accordion-body">
                <p className="mb-3">South Africa was nominated as one of the 8 (eight) IMO Member States to be part of the JTWG. SAMSA continues to work with international counterparts to ensure that GBV at Sea is mainstreamed and that relevant amendments are made to conventions to ensure that this issue is adequately covered in terms of training, reporting and case management.</p>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab5"
                aria-expanded="false"
                aria-controls="blackTab5">
                The Good News!! The 5th ILO Special Tripartite Committee of the MLC , 2006 at its meeting
              </button>
            </h2>
            <div id="blackTab5"
              className="accordion-collapse collapse"
              data-bs-parent="#blackTab">
              <div className="accordion-body">
                <p className="mb-3">The Good News!! The 5th ILO Special Tripartite Committee of the MLC , 2006 at its meeting held on 07 -11 April 2025, adopted the proposed amendments to the MLC, 2006 which ensured that for the first time the MLC covers issues of violence and harassment, including sexual harassment, bullying and sexual assault. This is a big milestone in efforts to advance gender inclusivity in the shipping industry by ensuring that female seafarer’s human rights are protected.

                </p>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab6"
                aria-expanded="false"
                aria-controls="blackTab6">
                Are you a victim of Gender Based violence
              </button>
            </h2>
            <div id="blackTab6"
              className="accordion-collapse collapse"
              data-bs-parent="#blackTab">
              <div className="accordion-body">
                <p className="mb-3">
                  Are you a victim of Gender Based violence (including violence and harassment, including sexual harassment, bullying and sexual assault.) or need someone to talk to?
                </p>
                <ul class="green-star-ul">
                  <li style={{ display: 'block' }}>Contact SAMSA’s Maritime Welfare Officer through our discreet line <a href="mailto:welfare@samsa.org.za">welfare@samsa.org.za</a>  this email is manned by a qualified Social Worker, experienced in GBV cases and trauma counselling.

                  </li>
                  <li style={{ display: 'block' }}>Your cases will be treated discreetly. You can also contact +27(O) 21 421 6170 and request to speak to the Maritime Welfare Officer.

                  </li>
                </ul>

              </div>
            </div>
          </div>

          {/* <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTab7"
                aria-expanded="false"
                aria-controls="blackTab7">
                For more information on GBV find resources:
              </button>
            </h2>
            <div id="blackTab7"
              className="accordion-collapse collapse"
              data-bs-parent="#blackTab">
              <div className="accordion-body">
                <p className="mb-3">
                  <ul class="green-star-ul">
                    <li>
                      <a href="/Documents/GBV/GBVSeaBrochure.pdf" target="_blank" rel="noopener noreferrer">GBV Brochure</a>
                     
                    </li>
                    <li>
                      <a href="https://blog.samsa.org.za/2023/01/10/wrap-south-african-maritime-sector-inaugural-gbv-seminar-cape-town-24-25-november-2022/">2022 GBV at Sea Seminar </a>

                    </li>
                    <li><a href="https://youtu.be/8EzAMI_sC1U">Shorter version of the seminar and pamphlet distribution campaign presented at the IMO ILO JTWG </a>
                    </li>

                  </ul>
                </p>
              </div>
            </div>
          </div> */}







        </div>

      </div>
      {/* <ul class="green-star-ul">
             <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
             
             <li>In reporting complaints falling outside the MLC i.e. fishing vessels, report the complaint to the company by following company’s procedures and if not satisfied contact any SAMSA office nearest to you, alternatively you can forward your complaint to welfare@samsa.org.za </li>
                  
           </ul>   */}
      <br />

      <p className="text-primary-color"></p>

    </>
  );
}

export default AboutGBV;